import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { empty } from 'rxjs';
import * as _lodash from 'lodash';
import { ProfileHttpService } from '../../../../profiles/services/profile-http.service';
import { ToastrService } from 'ngx-toastr';
import { ClientProfile } from '../../models/client-profile';
import { Profile } from '../../../../profiles/models/profile';
import { map, catchError } from 'rxjs';

@Component({
  selector: 'mojo-client-editor',
  templateUrl: './client-editor.component.html'
})
export class ClientEditorComponent implements OnInit {
  @Input() dialogTitle = 'Client Properties';
  @Input() profiles: Profile[] = [];

  @Output() onSaveComplete = new EventEmitter();
  @Output() onCancel = new EventEmitter();

  private clientProfile: ClientProfile;

  selectedProfile: Profile;
  allowActions = true;
  displayDialog: boolean;

  get selectedName(): string {
    return this.clientProfile ? this.clientProfile.name : '';
  }

  save(): void {
    this.profileHttpService.associateProfileWithClient(this.clientProfile.ref, this.selectedProfile.id).pipe(
      map(() => {
        this.displayDialog = false;
        this.allowActions = true;
        this.messageService.success(`Client '${this.clientProfile.name}' updated`, 'Client Updated');
        this.onSaveComplete.emit(null);
      }),
      catchError(() => {
        this.messageService.error(`Client '${this.clientProfile.name}' not saved`, 'Save Error');
        this.allowActions = true;
        return empty();
      })
    ).subscribe();

  }

  cancel(): void {
    this.displayDialog = false;
    this.onCancel.emit();
  }

  showDialog(clientProfile: ClientProfile): void {
    this.clientProfile = clientProfile;
    this.selectedProfile = this.clientProfile.profile;
    this.displayDialog = true;
  }

  ngOnInit() { }

  constructor(private profileHttpService: ProfileHttpService,
    private messageService: ToastrService) {
  }
}
